import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { create_service, delete_service, fetch_services, update_service } from './api';
import type { CreateServiceRequest, UpdateServiceRequest } from './types';

const SERVICES_KEY = ['vendor-services'] as const;

export function use_services() {
  return useQuery({ queryKey: SERVICES_KEY, queryFn: fetch_services });
}

export function use_create_service() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateServiceRequest) => create_service(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: SERVICES_KEY }),
  });
}

export function use_update_service() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateServiceRequest }) => update_service(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: SERVICES_KEY }),
  });
}

export function use_delete_service() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete_service(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: SERVICES_KEY }),
  });
}
